// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// lazy init
let messagingPromise = null;

async function getMessagingSafely() {
  try {
    const supported = await isSupported();
    if (!supported) return null;

    // cache
    return getMessaging(app);
  } catch (e) {
    console.warn("Firebase messaging not supported / failed:", e);
    return null;
  }
}

export async function requestPermission() {
  // Guard Notification API
  if (typeof window === "undefined" || !("Notification" in window)) {
    console.warn("Notifications API not supported in this browser.");
    return null;
  }

  // Guard secure context + service worker (needed for push)
  if (!window.isSecureContext || !("serviceWorker" in navigator)) {
    console.warn("Push requires HTTPS + Service Worker support.");
    return null;
  }

  const messaging = await getMessagingSafely();
  if (!messaging) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("User Permission Denied:", permission);
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey:
        "BEM5hSiGeLpiMxh3_61NICdYaeQf7eZ9WSSfm2O-9wR6UvzwVY7Tm0PczhuG8X0Gikz32HzOj8wB5_l2-YSPc3w",
    });

    if (currentToken) {
      // console.log("Client Token:", currentToken);
      sessionStorage.setItem("fcm", currentToken);
      return currentToken;
    } else {
      console.log("Failed to generate the app registration token");
      return null;
    }
  } catch (err) {
    console.log("Token/permission error:", err);
    return null;
  }
}

export async function onMessageListener() {
  const messaging = await getMessagingSafely();
  if (!messaging) return null;

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => resolve(payload));
  });
}